import { createContext } from "react";
/**
 * When true, inner layouts (DashboardLayout, OwnerLayout) become
 * transparent pass-throughs so the sidebar isn't rendered twice.
 */
export const AppLayoutContext = createContext(false);
